/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

export {
  discriminators,
  Answer,
  CreativeWork,
  ErrorModel,
  ErrorResponse,
  Identifiable,
  Query,
  QueryContext,
  Response,
  ResponseBase,
  SearchResponse,
  SearchResultsAnswer,
  Thing,
  WebMetaTag,
  WebPage,
  WebWebAnswer
} from "../models/mappers";
